import * as Blockly from 'blockly/core'

function toHex(num) {
  return '#' + num.toString(16).padStart(6, '0')
}

export const tmBlocklyTheme = Blockly.Theme.defineTheme('tm', {
  name: 'tm',
  base: Blockly.Themes.Classic,
  blockStyles: {
    events_blocks: {
      colourPrimary: toHex(0xf5a623),
      colourSecondary: toHex(0xffd580),
      colourTertiary: toHex(0xb97a1a),
      hat: '',
    },
    motion_blocks: {
      colourPrimary: toHex(0x4a90e2),
      colourSecondary: toHex(0x7ab0e8),
      colourTertiary: toHex(0x2e6aab),
    },
    looks_blocks: {
      colourPrimary: toHex(0x9966cc),
      colourSecondary: toHex(0xb58ad9),
      colourTertiary: toHex(0x6b4588),
    },
    sound_blocks: {
      colourPrimary: toHex(0x4caf50),
      colourSecondary: toHex(0x7bcb7f),
      colourTertiary: toHex(0x2f7d33),
    },
    logic_blocks: {
      colourPrimary: toHex(0xff8c00),
      colourSecondary: toHex(0xffa94d),
      colourTertiary: toHex(0xb36200),
    },
    loop_blocks: {
      colourPrimary: toHex(0xff6f61),
      colourSecondary: toHex(0xff9a8e),
      colourTertiary: toHex(0xb34a40),
    },
    end_blocks: {
      colourPrimary: toHex(0xe74c3c),
      colourSecondary: toHex(0xed7466),
      colourTertiary: toHex(0xa03022),
    },
  },
  componentStyles: {
    workspaceBackgroundColour: toHex(0xfafbfc),
    toolboxBackgroundColour: toHex(0xffffff),
    toolboxForegroundColour: toHex(0x1a1a1a),
    flyoutBackgroundColour: toHex(0xf5f5f5),
    flyoutForegroundColour: toHex(0x1a1a1a),
    flyoutOpacity: 1,
    scrollbarColour: toHex(0xcfd8dc),
    insertionMarkerColour: toHex(0xf5a623),
    insertionMarkerOpacity: 0.4,
    markerColour: toHex(0x4a90e2),
    cursorColour: toHex(0x4a90e2),
    selectedGlowColour: toHex(0x4a90e2),
    selectedGlowOpacity: 0.5,
  },
  fontStyle: {
    family: '"Quicksand", "Nunito", system-ui, sans-serif',
    weight: '700',
    size: 14,
  },
  startHats: true,
})
